import React, { memo } from 'react';
import PropTypes from 'prop-types';

const PendencyTag = ({ value, color }) => {
  return (
    <div className="pendency-tag" style={{ background: color }}>
      {value}
    </div>
  );
};

PendencyTag.propTypes = {
  value: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default memo(PendencyTag);
